import { analytics } from '@redislabsdev/cloud-ui-analytics';
import { useQueryClient } from '@tanstack/react-query';
import { useFeatureFlags } from 'components/FeatureFlagsProvider/hooks/useFeatureFlags';
import usersKeys from 'queryClient/users/users.keys';
import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { getAccountStateSelector } from 'store/account/account.selectors';
import { ApiAuthResponse } from 'store/auth/auth.types';

export const useIdentifyAnalytics = () => {
  const queryClient = useQueryClient();

  const user = queryClient.getQueryData<ApiAuthResponse | undefined>(usersKeys.getCurrentUser);
  const { data: account } = useSelector(getAccountStateSelector);
  const {
    flags: { enableHighMemoryUsageWithEvictionAbTest }
  } = useFeatureFlags();

  useEffect(() => {
    if (user?.user_id && account?.id) {
      analytics.identify(String(user.user_id), {
        accountId: account.id,
        accountName: account.name,
        role: user.role,
        auth: user.auth_mode,
        email: user.email,
        fullName: user.name,
        enableHighMemoryUsageWithEvictionAbTest
      });
    }
  }, [
    user?.user_id,
    user?.role,
    user?.auth_mode,
    user?.email,
    user?.name,
    account?.id,
    account?.name,
    enableHighMemoryUsageWithEvictionAbTest
  ]);
};
